const styles = `:host(:not([hidden])) {
  /* Using !important here is necessary. The most common reason is for MUI to add
    * { box-sizing: content-box; }
    and that will override any
    :host { box-sizing: border-box }
    in our code
  */
  box-sizing: border-box !important;
  border-top: 1px solid var(--goto-border-color-default);
  color: var(--goto-text-02);
  display: block;
  width: 100%;
}`; export default styles;